var React = require('react');

function StatusWarning (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16.733 3.187c.173.101.323.237.441.398l.082.125L29.99 25.54a1.455 1.455 0 01-1.102 2.18l-.154.007H3.266a1.455 1.455 0 01-1.327-2.05l.07-.137L14.745 3.71a1.455 1.455 0 011.989-.523zM16 21.455a1.212 1.212 0 100 2.424 1.212 1.212 0 000-2.424zM16.727 11h-1.454v8h1.454v-8z"})));
}

StatusWarning.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = StatusWarning;

StatusWarning.default = StatusWarning;
